import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Box } from "@mui/material";

export const LoginHeader = () => {
  return (
    <>
      <AppBar className='header-container' position='fixed'>
        <Toolbar disableGutters>
          <Box className='header-md-block md-fex-grow-block'></Box>
        </Toolbar>
      </AppBar>
    </>
  );
};
